import { render, staticRenderFns } from "./AddressInfoWrapper.vue?vue&type=template&id=5b7f087a"
import script from "./AddressInfoWrapper.vue?vue&type=script&lang=js"
export * from "./AddressInfoWrapper.vue?vue&type=script&lang=js"
import style0 from "./AddressInfoWrapper.vue?vue&type=style&index=0&id=5b7f087a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports